import { useSheetContext } from "@/context/sheet";
import { useCreateProvider } from "@/hooks/providers";
import { CreateProvider } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(providers)/providers/_sheet/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutateAsync } = useCreateProvider({
    onSuccess: (provider) => {
      close(() => {
        navigate({
          to: "/providers",
          params: { id: provider.id.toString() },
        });
      });
    },
  });

  const create = async (provider: CreateProvider) => {
    await mutateAsync(provider);
  };

  return <Form onUpsert={create} />;
}
